

















import { Component, Prop, Vue } from "vue-property-decorator";
import userApi from "@/api/userApi";
import _ from "lodash";

@Component({
  name: 'ResetPassword'
})
export default class ResetPassword extends Vue {
  public form = {
    password: '',
    password_confirmation: ''
  }
  public errorMessage = '';

  @Prop({ default: '' })
  public username;

  @Prop({ default: '' })
  public token;

  private async submit():Promise<void> {
    // Call api reset password
    const response = await userApi.resetPassword(this.token, this.form);

    if (_.get(response, 'meta.status') != 200) {
      // Show error
      this.errorMessage = _.get(response, 'meta.errors.password.0', _.get(response, 'meta.message'));
    } else {
      // Show PR40
      this.$emit('submit');
    }
  }

}
